import { CircularProgress, Box, ButtonBase } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { formatPrice } from '@ocx-app/lib/formatters/formatPrice';
import { SizingMultiplier, Typography } from '@ocx/ui';

import { PointsStrategy } from '@ocx/graphql';
import { LoyaltyCurrencyIcon } from '@ocx/feat-loyalty-currency';

type LoyaltyCurrencyBalanceProps = {
  points: number;
  pointsStrategy: Exclude<PointsStrategy, PointsStrategy.NotUsed>;
  loading?: boolean;
  onClick?(): void;
};
export const LoyaltyCurrencyBalance = (props: LoyaltyCurrencyBalanceProps) => {
  const { points, pointsStrategy, loading, onClick = () => {} } = props;
  const intl = useIntl();

  return (
    <ButtonBase sx={{ borderRadius: '16px', position: 'relative', flexShrink: 0 }} onClick={onClick}>
      <Box display="flex" alignItems="center" sx={{ opacity: loading ? 0.1 : 1 }}>
        <Typography variant="h6" component="span" mr={SizingMultiplier.xs}>
          {pointsStrategy === PointsStrategy.Cents && formatPrice(points)}
          {pointsStrategy === PointsStrategy.Points && (
            <FormattedMessage
              id="loyalty:pointsStrategy:points:title"
              defaultMessage="{points} pts"
              description="Points title under the points number for points strategy POINTS"
              values={{ points: intl.formatNumber(points) }}
            />
          )}
        </Typography>
        <LoyaltyCurrencyIcon size="large" variant="multiple" />
      </Box>
      {loading && (
        <Box position="absolute" display="flex" top={0} bottom={0} left={0} right={0}>
          <CircularProgress size={24} color="primary" sx={{ m: 'auto' }} />
        </Box>
      )}
    </ButtonBase>
  );
};
